import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ActionType, IActionType} from '../../shared/model/action-type.model';
import {ActionTypeService} from './action-type.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Organization} from "../../shared/model/organization.model";
import {IStep, Step} from "../../shared/model/step.model";
import {StepService} from "../step/step.service";


@Component({
  selector: 'app-action-type-update',
  templateUrl: './action-type-update.component.html'
})
export class ActionTypeUpdateComponent implements OnInit {
  actionType: IActionType = new ActionType();
  isSaving: boolean;
  @Input() actionTypeEdit;

  steps: IStep[];
  constructor(protected actionTypeService: ActionTypeService, protected activatedRoute: ActivatedRoute, public activeModal: NgbActiveModal, public stepService: StepService) {
  }

  ngOnInit() {
    // alert(' in id===' + this.phoneTypeEdit);
    // if (this.actionTypeEdit) {
    //
    //   this.actionTypeService.find(this.actionTypeEdit).subscribe(
    //     (res: HttpResponse<IActionType>) => {
    //       this.actionType = res.body;
    //       // alert(this.actionType);
    //     },
    //     (res: HttpErrorResponse) => this.onError(res.message)
    //   );
    // }
    // this.isSaving = false;
    // this.activatedRoute.data.subscribe(({ actionType }) => {
    //     this.actionType = actionType;
    // });
    this.loadAllStep();
  }

  previousState() {
    window.history.back();
  }


  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }

  loadAllStep() {
    this.stepService.query({
      page: 0,
      size: 15,
      sort: ['score', 'asc']

    }).subscribe(
      (res: HttpResponse<IStep[]>) => {
        this.steps = res.body;
        if (this.actionTypeEdit) {

          this.actionTypeService.find(this.actionTypeEdit).subscribe(
            (res: HttpResponse<IActionType>) => {
              this.actionType = res.body;
              if(this.actionType.step && this.actionType.step.id) {
                this.actionType.step_str = this.actionType.step.id;
              }
              // alert(this.actionType);
            },
            (res: HttpErrorResponse) => this.onError(res.message)
          );
        }
        this.isSaving = false;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  save() {
    this.isSaving = true;
    // this.actionType.organization = new Organization(1);
    if (this.actionType.step_str && this.actionType.step_str === '-1') {
      this.actionType.step = null;

    } else {
      if (this.actionType.step_str){
        this.actionType.step = new Step(this.actionType.step_str);
    }
    }

    if (this.actionType.id !== undefined) {
      this.subscribeToSaveResponse(this.actionTypeService.update(this.actionType));
    } else {
      this.subscribeToSaveResponse(this.actionTypeService.create(this.actionType));
    }
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<IActionType>>) {
    result.subscribe((res: HttpResponse<IActionType>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError());
  }


  // private subscribeToSaveResponse(result: Observable<DocumentType>) {
  //   result.subscribe((res: DocumentType) =>
  //     this.onSaveSuccess(res), (res: Response) => {
  //     this.onSaveError();
  //   }) }
  protected onSaveSuccess() {
    this.isSaving = false;
    this.activeModal.dismiss();

    // this.previousState();
  }

  protected onSaveError() {
    this.isSaving = false;
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }


}
